import { ref, get, update } from "firebase/database";
import { database } from "../../../../Utils/firebase";
import GetInvoiceDataFirebase from "../../Invoice/GetInvoiceDataFirebase";

const DeleteAssignerUserInvoiceDataInFirebase = async (state, dispatch, uniqueID, userID, ownerUid) => {
    if (!ownerUid) return null;
    

    try {
        // Reference to the specific invoice in Firebase
        const userRef = ref(
            database,
            `invoiceGenerator/users/${ownerUid}/billInvoice/${uniqueID}`
        );

        // First check if invoice exists
        const snapshot = await get(userRef);
        if (!snapshot.exists()) {
            return { success: false, message: "Invoice not found." };
        }

        // Instead of deleting, just mark as deleted
        await update(userRef, { isDeleted: true,
            deletedBy: state?.USERID || "guest" });

        // Fetch updated invoice data
        await GetInvoiceDataFirebase(state, dispatch);

        return { success: true, message: "Invoice marked as deleted!" };
    } catch (error) {
        return {
            success: false,
            message: error.message || "Failed to mark invoice as deleted.",
        };
    }
};

export default DeleteAssignerUserInvoiceDataInFirebase;
